/**
 * openOverlapAnalysisWindow — the "New window" destination for the Overlap
 * Analysis report.
 *
 * The target is a fresh `about:blank` this app just opened, which is the one
 * situation in which `document.write` is not a footgun: there is no loaded
 * document to blow away. A `blob:` URL was the alternative and was rejected
 * because a blob document can trip a deployed environment's CSP, whereas
 * `about:blank` inherits this origin and cannot.
 *
 * The window is NAMED, so pressing the button again replaces the content of the
 * window already open rather than stacking a new one on every click.
 */

/** Window name, so repeat opens reuse one window instead of stacking. */
export const OVERLAP_WINDOW_NAME = "ln2OverlapAnalysis";

/** Features string: wide enough for the four-column occurrence tables. */
const OVERLAP_WINDOW_FEATURES = "width=1100,height=800,resizable=yes,scrollbars=yes";

/**
 * Write a report document into a popup, returning the window or `null`.
 *
 * `null` is the blocked-popup answer and is a normal outcome, not an error: the
 * call is inside a click handler so most blockers permit it, but not all. The
 * caller is expected to fall back to the in-app panel and say so — silently
 * producing nothing is how an operator concludes the button is broken.
 *
 * `opener` is injectable so the blocked path is testable without a real window.
 */
export function openOverlapAnalysisWindow(
  html: string,
  opener: Pick<Window, "open"> = window,
): Window | null {
  const win = opener.open("", OVERLAP_WINDOW_NAME, OVERLAP_WINDOW_FEATURES);
  if (!win) return null;
  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();
  return win;
}
